import { useState } from "react";
import { IoClose } from "react-icons/io5";

const COINS = [
    { id: 1, value: 90 },
    { id: 2, value: 120 },
    { id: 3, value: 250 },
    { id: 4, value: 400 },
    { id: 5, value: 500 },
    { id: 6, value: 750 },
    { id: 7, value: 900 },
    { id: 8, value: 1000 },
];

export default function SelectWelcomeGift({
    onClose,
    selectedCoin,
    onSelect,
}) {
    const [current, setCurrent] = useState(selectedCoin);

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
            {/* Popup */}
            <div className="w-[90%] max-w-sm bg-white rounded-2xl p-5">
                {/* Header */}
                <div className="flex justify-between items-center mb-4">
                    <h3 className="font-semibold text-lg">Select Gift</h3>
                    <button
                        onClick={onClose}
                        className="text-xl font-bold text-gray-500"
                    >
                        <IoClose/>
                    </button>
                </div>

                {/* Coins Grid */}
                <div className="grid grid-cols-4 gap-3 mb-6">
                    {COINS.map((coin) => {
                        const isSelected = current === coin.value;

                        return (
                            <button
                                key={coin.id}
                                onClick={() => setCurrent(coin.value)}
                                className={`border rounded-xl py-3 flex flex-col items-center justify-center transition-all
                  ${isSelected
                                        ? "border-red-500 bg-red-50"
                                        : "border-gray-400"
                                    }
                `}
                            >
                                <img src="./images/goldcoin.png" alt="coin" className="w-4 h-4 rounded-full object-cover" />
                                <span className="text-sm font-medium mt-1">
                                    {coin.value}
                                </span>
                            </button>
                        );
                    })}
                </div>

                {/* Select Button */}
                <button
                    disabled={!current}
                    onClick={() => {
                        onSelect(current);
                        onClose();
                    }}
                    className={`w-full py-3 rounded-full font-medium transition-all
            ${current
                            ? "bg-red-500 text-white"
                            : "bg-gray-300 text-gray-500 cursor-not-allowed"
                        }
          `}
                >
                    Select
                </button>
            </div>
        </div>
    );
}